import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useYearLinks } from 'src/client/containers/Updates/useYearLinks';
import { routes } from 'src/client/utils/router';
import styled from 'styled-components/macro';

export const StaffSelectionHeader = () => {
  const { backLink, forwardLink, year } = useYearLinks({
    startYear: 2017,
    basePath: '/updates/staff',
    routeMatch: routes.updates.routes.staffSelections,
  });

  return (
    <>
      {backLink}
      <Title>
        <FormattedMessage id="updates.staff.headline" defaultMessage={`Staff Selections ${year}`} values={{ year }} />
      </Title>
      {forwardLink}
    </>
  );
};

const Title = styled.span`
  margin: 0 10px;
`;
